import { UserInfo } from "./user-info.model";

export class AuthenticatedUser {
  public firstName: string;
  public lastName: string;
  public email: string;
  public preferredUsername: string;

  constructor(userInfo: UserInfo) {
    if(userInfo && userInfo.claims){
      let claims = Object.fromEntries(userInfo.claims.map((x: { type: string, value: string }) => [x.type, x.value]));
      this.firstName = claims.given_name;
      this.lastName = claims.family_name;
      this.email = claims.email;
      this.preferredUsername = claims.preferred_username;
    }
  }
}
